import { supabase } from '@/integrations/supabase/client';
import type { OnboardingWebhookEvent } from '@/constants/onboarding';

export interface NotifyOnboardingWebhookParams {
  step_key?: string;
  step_index?: number;
  event?: OnboardingWebhookEvent;
}

export async function notifyOnboardingWebhook(
  userId: string,
  params: NotifyOnboardingWebhookParams = {}
): Promise<void> {
  const { error } = await supabase.functions.invoke('onboarding-webhook', {
    body: {
      user_id: userId,
      step_key: params.step_key ?? null,
      step_index: params.step_index ?? null,
      event: params.event ?? null,
    },
  });
  if (error) {
    console.error('[onboarding-webhook]', error);
  }
}
